class Cards2 {
	constructor(config) {
		this.config = Object.assign({
			scope: '.cards_2',
		}, config);

			this.$scope = $(this.config.scope);

			if (this.$scope.length > 0) {
				this.init();
			}
	}

	init() {
		this.$scope.each((index, element) => {
			this.#animateBorders(element);
		});
	}

	#animateBorders(scope) {
		const borders = scope.querySelectorAll('.card-animated-border');
		if (borders.length === 0) return;

		let current = 0;
		borders[0].classList.add('is-active');

		setInterval(() => {
			borders[current].classList.remove('is-active');
			current = (current + 1) % borders.length;
			borders[current].classList.add('is-active');
		}, 6000);
	}
}

export default new Cards2;
